import type { ReactNode, RefAttributes } from "react";
import type * as lazyFunctions from "./lazyFunctions";
import { type LazyComponent, LazyModule, createLazyComponent } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyFunctions> = new LazyModule(() => import(/* webpackChunkName: "CalendarBootProjection" */ "./lazyFunctions"), { name: "CalendarBootProjection" });

export const ProjectionPopoutHost: LazyComponent<{
    children?: ReactNode | undefined;
} & RefAttributes<unknown>, unknown, void> = createLazyComponent(lazyModule, m => m.ProjectionPopoutHost);
